import { BaseRouteService } from 'core/services';

class ImportRouteService extends BaseRouteService {
    constructor() {
        super('import-headers');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,userId,statusId,facilityId,dateFrom,dateTo}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    getStatus(){
        return super.get(this.base + '/status');        
    }

    upload(resource){
        return super.create(this.base + '/upload', resource);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    getImportUsers(searchQuery){
        return super.find(this.base + '/import-users/{?searchQuery}', {searchQuery : searchQuery});
    }

    getPatientsByCategory(filter) {
        return super.find(this.base + '/patients-by-category/{?searchQuery,page,rpp,sort,embed,fields,facilityId,marketingRepId,dateFrom,dateTo}', filter);
    }

    changeIsFirst(resource) {
        return super.update(this.base + '/{id}/change-is-first/{isFirst}/{facilityId}', resource);
    }

    download(filter) {
        return super.find(this.base + '/download/{?searchQuery,sort,dateFrom,dateTo,marketingRepId,facilityId}', filter);    
    }

    downloadValidationReport(filter) {
        return super.find(this.base + '/download-validation-report/{?searchQuery,page,rpp,sort,userId,statusId,facilityId,dateFrom,dateTo}', filter);    
    }
}

export default ImportRouteService;
